// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimStripePaymentsDTO } from '../models';
/**
 * ClaimStripePaymentsApi - axios parameter creator
 * @export
 */
export const ClaimStripePaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets Stripe payments for a claim
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStripePayments(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling getClaimStripePayments.');
            }
            const localVarPath = `/v2/claims/{claimId}/stripe-payments`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimStripePaymentsApi - functional programming interface
 * @export
 */
export const ClaimStripePaymentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets Stripe payments for a claim
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStripePayments(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimStripePaymentsDTO> {
            const localVarAxiosArgs = ClaimStripePaymentsApiAxiosParamCreator(configuration).getClaimStripePayments(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimStripePaymentsApi - factory interface
 * @export
 */
export const ClaimStripePaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets Stripe payments for a claim
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStripePayments(claimId: string, options?: any) {
            return ClaimStripePaymentsApiFp(configuration).getClaimStripePayments(claimId, options)(axios, basePath);
        },
    };
};

/**
 * ClaimStripePaymentsApi - interface
 * @export
 * @interface ClaimStripePaymentsApi
 */
export interface ClaimStripePaymentsApiInterface {
    /**
     * Gets Stripe payments for a claim
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimStripePaymentsApiInterface
     */
    getClaimStripePayments(claimId: string, options?: any): AxiosPromise<ClaimStripePaymentsDTO>;

}

/**
 * ClaimStripePaymentsApi - object-oriented interface
 * @export
 * @class ClaimStripePaymentsApi
 * @extends {BaseAPI}
 */
export class ClaimStripePaymentsApi extends BaseAPI implements ClaimStripePaymentsApiInterface {
    /**
     * Gets Stripe payments for a claim
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimStripePaymentsApi
     */
    public getClaimStripePayments(claimId: string, options?: any) {
        return ClaimStripePaymentsApiFp(this.configuration).getClaimStripePayments(claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimStripePaymentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Gets Stripe payments for a claim
 * @param {string} claimId 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getClaimStripePayments(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimStripePaymentsDTO> {
    const localVarAxiosArgs = ClaimStripePaymentsApiAxiosParamCreator(configuration).getClaimStripePayments(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

